exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-container {\n  width: 280px;\n  padding: 15px 15px; }\n  .custom-container .custom-button {\n    display: inline-block;\n    min-width: 250px;\n    margin: 6px 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/main/pda-inv-main.component.scss
// module id = ../../../../../src/app/agatextscreens/pda/inventory/main/pda-inv-main.component.scss
// module chunks = 0